<template>
  <div class="app-wrap">
    <div v-if="isLoading" class="se-pre-con"></div>
    <img alt="Gomobile logo" src="@/assets/logo.svg" class="company-logo" />
    <form v-if="!showThanks" action="#">
      <div class="paragraph-wrap">
        <h1 class="text-bold text-primary no-top-margin">
          {{ $t("main.header") }}
        </h1>
        <p class="paragraph">{{ $t("main.text1") }}</p>
        <p class="paragraph">{{ $t("main.text2") }}</p>
        <h2 class="text-bold text-primary">{{ $t("name.header") }}</h2>
        <TextareaAutosize
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.name"
          type="text"
          :min-height="10"
          :max-height="350"
          :placeholder="$t('name.placeholder')"
        />

        <h2
          :class="{ alertLine: isAlert }"
          class="top-wrap text-bold"
          id="must-answer"
        >
          <span class="text-primary custom-asterisk">*</span>
          {{ $t("questions.q1.header") }}
          <span v-if="isAlert" class="text-primary custom-asterisk"
            >({{ $t("isNecessary.text") }})</span
          >
        </h2>
        <ThePointsbar
          @change="onAsoNpsChange($event)"
          :size="10"
          code="asoNps"
          :full-name="true"
        />

        <h2 class="text-bold text-primary">{{ $t("questions.q2.header") }}</h2>
        <ThePointsbar
          @change="feedbackData.kpiDynamics = String($event)"
          :size="5"
          code="kpiDyn"
          :full-name="false"
        />

        <h2 class="text-bold text-primary">{{ $t("questions.q3.header") }}</h2>
        <p class="paragraph sub-question">{{ $t("questions.q3.sub") }}</p>
        <ThePointsbar
          @change="feedbackData.reportingQuality = String($event)"
          :size="5"
          code="report"
          :full-name="false"
        />

        <h2 class="text-bold text-primary">{{ $t("questions.q4.header") }}</h2>
        <ThePointsbar
          @change="feedbackData.priceVsMarket = String($event)"
          :size="5"
          code="price"
          :full-name="false"
        />

        <h2 class="text-bold text-primary">{{ $t("questions.q5.header") }}</h2>
        <p class="paragraph sub-question">{{ $t("questions.q5.sub") }}</p>
        <ThePointsbar
          @change="feedbackData.teamInteraction = String($event)"
          :size="5"
          code="team"
          :full-name="false"
        />

        <h2 class="top-wrap text-bold text-primary">
          {{ $t("questions.q6.header") }}
        </h2>
        <TextareaAutosize
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.likeMost"
          :min-height="10"
          :max-height="350"
          name="like_most"
        />

        <h2 class="top-wrap text-bold text-primary">
          {{ $t("questions.q7.header") }}
        </h2>
        <TextareaAutosize
          :class="
            screenWidth > 768
              ? 'feedback-textarea desktop-textarea'
              : 'feedback-textarea'
          "
          v-model="feedbackData.improve"
          :min-height="10"
          :max-height="350"
          name="improve"
          :placeholder="$t('questions.q7.placeholder')"
        />
      </div>
      <button type="button" class="submit-button" @click="sendFeedback">
        <span>{{ $t("sendBtn") }}</span
        ><img src="@/assets/message.svg" />
      </button>
    </form>
    <div v-else class="thanks-text">
      <h1>{{ $t("thanks.header") }}</h1>
      <p>{{ $t("thanks.text1") }}</p>
      <p>
        {{ $t("thanks.text2") }}
        <a
          class="enable-select"
          :href="`mailto:${$t('thanks.email')}`"
          >{{ $t("thanks.email") }}</a
        >.
      </p>
    </div>
  </div>
</template>

<script>
import ThePointsbar from "@/components/ThePointsbar";
import TextareaAutosize from "@/components/TextareaAutosize.vue";
import API from "@/api";

export default {
  name: "App",
  components: {
    ThePointsbar,
    TextareaAutosize,
  },
  data: function () {
    return {
      showThanks: false,
      isLoading: false,
      isAlert: false,
      feedbackData: {
        table: process.env.VUE_APP_LANGUAGE === "en" ? "ww" : "simple",
        version: "aso_feedback_v1",
        name: "",
        asoNps: "",
        kpiDynamics: "",
        reportingQuality: "",
        priceVsMarket: "",
        teamInteraction: "",
        likeMost: "",
        improve: "",
        paramName: "",
      },
    };
  },

  methods: {
    extractParamFromUrl(url) {
      try {
        const parsedUrl = new URL(url);
        return parsedUrl.searchParams.get("param") || "";
      } catch (e) {
        return "";
      }
    },
    onAsoNpsChange(val) {
      this.feedbackData.asoNps = String(val);
      this.isAlert = false;
    },
    sendFeedback: async function () {
      if (!this.feedbackData.asoNps || this.feedbackData.asoNps.length === 0) {
        document
          .getElementById("must-answer")
          .scrollIntoView({ block: "center", behavior: "smooth" });
        this.isAlert = true;
        return;
      }

      this.isLoading = true;
      const that = this;
      try {
        if (this.feedbackData.paramName === "" && window.location.search.includes("param=")) {
          await this.getData();
        }
        if (this.feedbackData.paramName === "") {
          this.feedbackData.paramName =
            "Клиент стер уникальный параметр ссылки";
        }
        const api = new API();
        await api.push(this.feedbackData).then(function () {
          that.isLoading = false;
        });
        that.isLoading = false;
      } catch (e) {
        console.error(e);
      }
      this.showThanks = true;
    },
    getData: async function () {
      try {
        const currentParam = new URLSearchParams(window.location.search).get("param");
        if (!currentParam) {
          return;
        }

        const requestOptions = {
          method: "GET",
          redirect: "follow",
        };

        const response = await fetch(
          "https://script.google.com/macros/s/AKfycbz6nXZwOixTOAYU8AZ2nx-_fuF3ABLGM1AaoUx5yUdFdcE_FS_l1aavuEViiK0xDs_yEg/exec",
          requestOptions
        );
        const result = await response.json();

        const matchedRow = result.find((row) => {
          if (!Array.isArray(row) || row.length < 2) {
            return false;
          }
          return this.extractParamFromUrl(row[1]) === currentParam;
        });

        if (matchedRow) {
          this.feedbackData.paramName = matchedRow[0];
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    screenWidth() {
      return window.innerWidth;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.scale-hint,
.sub-question {
  margin-top: 0.25em;
  margin-bottom: 0.5em;
  color: #939393;
  font-size: 15px;
}
.sub-question {
  font-style: italic;
}
</style>
